<template>
  <div class="pdfDiv">
    <div class="small">
      <div class="arrow">
        <div @click="changePdfPage(0)" class="turn" :class="{grey: currentPage==1}">上一页</div>
        <div class="txt">{{currentPage}} / {{pageCount}}</div>
        <div @click="changePdfPage(1)" class="turn" :class="{grey: currentPage==pageCount}">下一页</div>
<!--        <div @click="screen" class="screen">全屏展示</div>-->
      </div>
      <pdf :src="src" class="pdf" ref="pdfs"
           :page="currentPage" @num-pages="pageCount=$event"
           @page-loaded="currentPage=$event" @loaded="loadPdfHandler">
      </pdf>
    </div>
  </div>
</template>

<script>
  import pdf from 'vue-pdf'

  export default {
    props: {
      material: {
        type: Array
      }
    },
    components: {
      pdf
    },
    data () {
      return {
        currentPage: 1, // pdf文件页码
        pageCount: 0, // pdf文件总页数
        src: ''
      }
    },
    created () {
      this.id = this.$parent.id
      this.timer = setInterval(res => {
        this.htmlTime++
      }, 1000)
      this.src = this.material[0].src
    },
    destroyed () {
      this.$http.post('/apipx/Lesson/studyrecord', {
        lesson_id: this.id,
        time_lenght: this.htmlTime,
        num: this.currentPage,
        total_num: this.pageCount,
        token: JSON.parse(localStorage.getItem('login')).token
      }).then(res => {
        clearInterval(this.timer)
      })
    },
    methods: {
      changePdfPage (val) { // 判断页数
        if (val === 0 && this.currentPage > 1) {
          this.currentPage--
        }
        if (val === 1 && this.currentPage < this.pageCount) {
          this.currentPage++
        }
      },
      // pdf加载时
      loadPdfHandler (e) {
        this.currentPage = 1 // 加载的时候先加载第一页
      },
      screen () {
        window.open(this.$parent.info.material[0].src)
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .pdfDiv {
    min-width: 100%;
    overflow-y: auto;
    overflow-x: auto;
    height: 100%;

    .class {
      width: 100%;
    }

    .small {
      padding-top: 50px;
      position: relative;
      overflow: hidden;

      /*&::-webkit-scrollbar {*/
      /*  display: block;*/
      /*}*/
    }

    .arrow {
      position: absolute;
      left: 50%;
      top: 0;
      height: 50px;
      line-height: 50px;
      text-align: center;
      width: 260px;
      margin: 0 0 0 -130px;
      color: #fff;

      .turn {
        width: 50px;
        cursor: pointer;
        display: inline-block;
      }

      .txt {
        width: 50px;
        display: inline-block;
      }

      .screen {
        width: 60px;
        cursor: pointer;
        display: inline-block;
      }

    }

    .pdf {
      height: 100%;
      margin: 0 auto;
      overflow: hidden;
      display: block !important;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/videoLayer/pdf/pdf.vue